// Simulate API call for payroll data
const samplePayrolls = [
  {
    id: 'PAY-2025-07',
    month: 'July',
    employeeName: 'Hashib Raja',
    employeeId: 'EMP123',
    designation: 'Senior Developer',
    department: 'Engineering',
    bankAccount: '**** **** **** 1234',
    baseSalary: 5000,
    allowances: 2000,
    allowanceDetails: {
      houseRent: 1000,
      medical: 500,
      transport: 300,
      meal: 200
    },
    deductions: 1000,
    deductionDetails: {
      tax: 500,
      providentFund: 250,
      insurance: 150,
      loan: 100
    },
    overtime: {
      hours: 10,
      ratePerHour: 30,
      amount: 300
    },
    grossSalary: 7300, // baseSalary + allowances + overtime
    netPay: 6300,  // grossSalary - deductions
    paymentStatus: 'Paid',
    paymentDate: '2025-07-25',
  }
];

export async function getPayrollByMonth(month) {
  // Simulate network delay
  await new Promise(res => setTimeout(res, 800));
  
  const payroll = samplePayrolls.find(p => p.month.toLowerCase() === month.toLowerCase());
  
  if (!payroll) {
    // Generate dummy data for any month
    return {
      ...samplePayrolls[0],
      id: `PAY-2025-${month}`,
      month: month,
      paymentDate: new Date().toISOString().split('T')[0]
    };
  }
  
  return payroll;
}
